import { useRouter } from "next/router";
import { useState } from "react";
import { FieldError, useForm } from "react-hook-form";

import Layout from "../../components/layouts/layout.comp";
import { LabelAndInput } from "../../components/reuseables/form.comp";
import { PwdRegex, changePassword } from "../../core/login.core";
import { useTranslation } from "../../core/translation.core";

interface FormData {
  currentPwd: string;
  newPwd: string;
}

export default function ChangePwd() {
  const { t, msg } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>();
  const { push } = useRouter();
  const [err, setErr] = useState("");

  async function onSubmit(data: FormData) {
    try {
      await changePassword(data);
      push("/");
    } catch (e) {
      setErr("There is an error");
    }
  }

  return (
    <Layout title={t(msg.user.changePwd)}>
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
        <PasswordError fieldError={errors.currentPwd} />
        <LabelAndInput<FormData>
          register={register}
          fieldName="currentPwd"
          type="password"
          label={t(msg.user.currentPwd)}
          registerOptions={{ required: true }}
        />
        <PasswordError fieldError={errors.newPwd} />
        <LabelAndInput<FormData>
          register={register}
          fieldName="newPwd"
          type="password"
          label={t(msg.user.newPwd)}
          registerOptions={{ required: true, pattern: PwdRegex }}
        />

        <input type="submit" value={t(msg.user.changePwd)} />
      </form>
    </Layout>
  );
}

const PasswordError = ({ fieldError }: { fieldError?: FieldError }) => {
  const { t, msg } = useTranslation();

  if (!fieldError) return null;

  if (fieldError.type === "required") return <p className="text-red-400">{t(msg.general.plsEnter)}</p>;
  if (fieldError.type === "pattern") return <p className="text-red-400">{t(msg.user.pwdStrengthNotice)}</p>;

  return null;
};
